
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningHeavySnowShowersNight as ObiLightningHeavySnowShowersNightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-heavy-snow-showers-night.js';
 
 
 

 
 export const ObiLightningHeavySnowShowersNight = createComponent({
   react: React,
   tagName: 'obi-lightning-heavy-snow-showers-night',
   elementClass: ObiLightningHeavySnowShowersNightElement,
   events: {
     
   }
  });
 
 